/**
 * @file 載入中動畫元件
 * @description 全畫面遮罩式載入動畫，用於非同步操作等待狀態
 */
import React from 'react';
import './loadingStyle.scss';

/** 載入動畫 Props */
interface LoadingProps {
  isLoading?: boolean;
}

const Loading: React.FC<LoadingProps> = ({ isLoading = true }) => {
  if (!isLoading) return null;
  return (
    <div className='loading_container'>
      <div className='loader'>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default Loading;
